// import { createRouter, createWebHistory } from 'vue-router';
import {
  createRouter,
  createWebHashHistory
} from "vue-router";
const router = createRouter({
  routes: [{
    name: "Login",
    path: "/login",
    component: () => import("@/views/Login.vue"),
  },
  {
    name: "Ticket",
    path: "/",
    component: () => import("@/views/Layout.vue"),
    redirect: "/homepage",
    hidden: true,
    children: [{
      path: "homepage",
      name: "homepage",
      component: () => import("@/views/Homepage.vue"),
      meta: {
        title: "Homepage"
      },
    },
    {
      path: "requirement",
      name: "requirement",
      component: () => import("@/views/Requirement/index"),
      meta: {
        title: "Hiring Kick-off",
      },
      children: [{
        path: "createRequirement",
        name: "createRequirement",
        component: () =>
          import("@/views/Requirement/createRequirement.vue"),
        meta: {
          title: "Hiring Kick-off",
          // title: "Hiring Kick-off / Create New Hiring Kick-off",
        },
      },
      {
        path: "requirementDetail",
        name: "requirementDetail",
        component: () =>
          import("@/views/Requirement/detail.vue"),
        meta: {
          title: "Hiring Kick-off",
          // title: "Hiring Kick-off / Hiring Kick-off Detail",
        },
      },
      ],
    },
    {
      path: "job-description",
      name: "job-description",
      component: () => import("@/views/JobDescription/index"),
      meta: {
        title: "Documentation / JD Library",
      },
      children: [{
        path: "editJob",
        name: "editJob",
        component: () =>
          import("@/views/JobDescription/editJob.vue"),
        meta: {
          title: "Documentation / JD Library" //"JD Library / Edit JD Library",
        },
      },],
    },
    {
      path: "InternalApplication",
      name: "InternalApplication",
      component: () => import("@/views/InternalApplication/index"),
      meta: {
        // title: "Internal Application",
        title: "Candidate Management"
      },
      children: [{
        path: "internalApplicationDetail",
        name: "internalApplicationDetail",
        component: () =>
          import("@/views/InternalApplication/detail.vue"),
        meta: {
          title: "Candidate Management"
          // title: "Internal Application",
          // title: "Internal Application / Internal Application Detail",
        },
      },
      {
        path: "internalApplicationEdit",
        name: "internalApplicationEdit",
        component: () =>
          import("@/views/InternalApplication/edit.vue"),
        meta: {
          title: "Candidate Management"
          // title: "Internal Application",
          // title: "Internal Application Detail / Edit Standard CV",
        },
      }
      ],
    },
    {
      path: "referralReward",
      name: "referralReward",
      component: () => import("@/views/referralReward/index"),
      meta: {
        title: "Internal Referra / Referral Reward",
      },
      children: [{
        path: "editReferralReward",
        name: "editReferralReward",
        component: () =>
          import("@/views/referralReward/editReferralReward.vue"),
        meta: {
          title: "Internal Referra / Referral Reward",
          // title: "Referral Reward ",
        },
      }
      ],
    },
    {
      path: "referralList",
      name: "referralList",
      component: () => import("@/views/referralList/index"),
      meta: {
        title: "Candidate Management"
        // title: "Internal Referral / Referral List",
      },
      children: [{
        path: "referralListDetail",
        name: "referralListDetail",
        component: () =>
          import("@/views/referralList/detail.vue"),
        meta: {
          title: "Candidate Management"
          // title: "Internal Referral / Referral List",
          // title: "Internal List / Internal Referral Detail",
        },
      }, {
        path: "referralListEdit",
        name: "referralListEdit",
        component: () =>
          import("@/views/referralList/edit.vue"),
        meta: {
          title: "Candidate Management"
          // title: "Internal Referral / Referral List",
          // title: "Internal Referral Detail / Edit Standard CV",
        },
      }
      ],
    },
    {
      path: "onboarding",
      name: "onboarding",
      component: () => import("@/views/PreOnboarding/index"),
      meta: {
        title: "Pre Onboarding",
      },
      children: [{
        path: "createOnboarding",
        name: "createOnboarding",
        component: () =>
          import("@/views/PreOnboarding/createOnboarding.vue"),
        meta: {
          title: "Pre Onboarding",
          // title: "Create New Pre Onboarding",
        },
      },
      {
        path: "onboardingDetail",
        name: "onboardingDetail",
        component: () =>
          import("@/views/PreOnboarding/detail.vue"),
        meta: {
          title: "Pre Onboarding",
          // title: "Pre Onboarding Detail",
        },
      },
      {
        path: "onboardingEdit",
        name: "onboardingEdit",
        component: () =>
          import("@/views/PreOnboarding/edit.vue"),
        meta: {
          title: "Pre Onboarding",
          // title: "Pre Onboarding Edit",
        },
      },
      ],
    },
    {
      path: "positionManagement",
      name: "positionManagement",
      component: () => import("@/views/positionManagement/index"),
      meta: {
        title: "Job Posting",
      },
      children: [{
        path: "createPosting",
        name: "createPosting",
        component: () =>
          import("@/views/positionManagement/createPosting.vue"),
        meta: {
          title: "Job Posting",
          // title: "Edit Job Posting",
        },
      },
      {
        path: "postingDetail",
        name: "postingDetail",
        component: () =>
          import("@/views/positionManagement/detail.vue"),
        meta: {
          title: "Job Posting",
          // title: "Job Posting Detail",
        },
      },
      ],
    },
    {
      path: "candidate",
      name: "candidate",
      component: () => import("@/views/candidateManagement/index"),
      meta: {
        title: "Candidate Management",
      },
      children: [{
        path: "candidateEdit",
        name: "candidateEdit",
        component: () =>
          import("@/views/candidateManagement/edit.vue"),
        meta: {
          title: "Candidate Management",
          // title: "Edit Candidate Management",
        },
      },
      {
        path: "candidateDetail",
        name: "candidateDetail",
        component: () =>
          import("@/views/candidateManagement/detail.vue"),
        meta: {
          title: "Candidate Management",
          // title: "Candidate Management Detail",
        },
      },
      ],
    },
    {
      path: "talent",
      name: "talent",
      component: () => import("@/views/talentPool/index"),
      meta: {
        title: "Talent Pool",
      },
      children: [{
        path: "talentEdit",
        name: "talentEdit",
        component: () =>
          import("@/views/talentPool/edit.vue"),
        meta: {
          title: "Talent Pool",
          // title: "Edit Talent Pool Management",
        },
      },
      {
        path: "talentDetail",
        name: "talentDetail",
        component: () =>
          import("@/views/talentPool/detail.vue"),
        meta: {
          title: "Talent Pool",
          // title: "Talent Pool Management Detail",
        },
      },
      ],
    },
    // {
    //   name: "setting",
    //   path: "/setting",
    //   component: () => import("@/views/Setting.vue"),
    //   meta: {
    //     title: "Setting",
    //   },
    // },
    {
      path: "configuration",
      name: "configuration",
      component: () => import("@/views/salaryBudget/index"),
      meta: {
        title: "Admin Center / Salary Benchmark",
      },
    },
    {
      path: "editcv",
      name: "editcv",
      component: () => import("@/components/EditCV.vue"),
      meta: {
        title: "Standard CV Edit",
      },
    }
    ],
  },
  ],
  history: createWebHashHistory(),
});
export default router;